/**
 * Localhost Development Configuration
 * Used when running on localhost:4000
 */

export const localhostConfig = {
  environment: 'localhost',
  hostname: 'localhost',

  api: {
    baseUrl: '/api', // Proxied through setupProxy.js
    firmwareBaseUrl: 'http://localhost:4000/api', // Backend via proxy
  },

  oauth: {
    clientId: 'provisioning-dev',
    redirectUri: 'http://localhost:4000/auth/callback',
    authUrl: 'https://sso.strong.blue/realms/anep-architecture/protocol/openid-connect/auth',
    tokenUrl: '/oauth/realms/anep-architecture/protocol/openid-connect/token',
  },

  ui: {
    title: 'StrongBlue Device Provisioning [LOCAL]',
    logoUrl: '/logo.jfif',
    companyName: 'Strong Blue',
    primaryColor: '#215EA1',
  },

  dev: {
    debug: true, // Always enable debug in localhost
  },
} as const;

export default localhostConfig;